import React from "react";

/* ═══════════════════════════════════════════════════════════════
   HOME PAGE LOADER
   A premium, Ayurveda-flavoured splash shown while the Home
   page's first-screen data (categories, treatments, doctors,
   banners) is loading. Pure inline SVG + CSS animation — no
   external gif/image dependency, so it always renders instantly
   and matches the brand palette exactly.
═══════════════════════════════════════════════════════════════ */
const HomeLoader = ({ visible }) => {
  return (
    <div className={`hc-loader ${visible ? "" : "hc-loader-hide"}`} role="status" aria-live="polite" aria-label="Loading">
      <div className="hc-loader-glow" aria-hidden="true" />

      <div className="hc-loader-mark">
        <svg viewBox="0 0 120 120" className="hc-loader-ring" aria-hidden="true">
          <circle cx="60" cy="60" r="52" className="hc-loader-ring-track" />
          <circle cx="60" cy="60" r="52" className="hc-loader-ring-arc" />
        </svg>

        <div className="hc-loader-badge">
          <img
            src="./front/assets/images/logo.png"
            alt="Shree Varma"
            className="hc-loader-logo"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        </div>
      </div>

      <div className="hc-loader-word">ACEVEDA</div>
      <div className="hc-loader-tag">Preparing your Ayurvedic wellness experience…</div>

      <div className="hc-loader-dots">
        <span /><span /><span />
      </div>
    </div>
  );
};

export default HomeLoader;